/**
 * TREATX-SOCIAL-REG-CORRECTNESS-01 — shared semantic mapper for social-auth
 * outcomes. Distinguishes AUTHENTICATION failures from REGISTRATION-not-
 * completed (gate) outcomes and ACCOUNT-ACCESS conditions, using stable
 * backend `detail.code`. Returns localized {title, message} via i18n `t`.
 * Never surfaces raw backend strings when a localized product message exists.
 */
export function mapSocialAuthError(t, status, code) {
  switch (code) {
    case 'soft_launch_signup_disabled':
      return { kind: 'registration', title: t('socialAuth.titleRegistration'), message: t('socialAuth.softLaunch') };
    case 'LEGAL_READINESS_RED':
      return { kind: 'registration', title: t('socialAuth.titleRegistration'), message: t('socialAuth.legalReadiness') };
    case 'pending_provider_application':
      return { kind: 'registration', title: t('socialAuth.titleRegistration'), message: t('socialAuth.pendingProviderApplication') };
    case 'account_deactivated':
      return { kind: 'access', title: t('socialAuth.titleAccess'), message: t('socialAuth.accountDeactivated') };
    case 'mfa_required_for_admin':
      return { kind: 'access', title: t('socialAuth.titleAccess'), message: t('socialAuth.mfaRequired') };
    case 'apple_oauth_disabled':
    case 'coming_soon':
      return { kind: 'auth', title: t('socialAuth.titleAuth'), message: t('socialAuth.appleDisabled') };
    default:
      break;
  }
  if (status === 401) {
    return { kind: 'auth', title: t('socialAuth.titleAuth'), message: t('socialAuth.sessionExpired') };
  }
  if (status === 0 || status === undefined || status === null) {
    return { kind: 'auth', title: t('socialAuth.titleAuth'), message: t('socialAuth.network') };
  }
  return { kind: 'auth', title: t('socialAuth.titleAuth'), message: t('socialAuth.authFailed') };
}
